import { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import delve from 'dlv';

import { checkAuthenticationStatus } from 'redux/reducers/authentication';
import { setOpusAccessBannerView } from 'redux/reducers/user/opusAccessBanner';
import { checkExternalLabelVisibilityStatus } from '../../../redux/reducers/authentication';

/**
 * This component is used to protect routes that need data from the WMG API
 * It wraps around the original component (the protected route) and returns it
 * if the isAuthenticated boolean in Redux is true. If you're not authenticated
 * in Redux it will redirect you to the homepage. The homepage in its turn
 * remembers the referrer page (the original route you wanted to visit) and
 * redirects you to that one if you call the authentication() dispatcher and
 * it resolves succesfully.
 */
class PrivateRoute extends Component {
  componentDidMount() {
    const {
      checkAuthenticationStatus,
      isAuthenticated,
      isExternalUser,
      checkExternalLabelVisibilityStatus,
      externalLoaded,
    } = this.props;
    checkAuthenticationStatus();

    if (isAuthenticated && isExternalUser && !externalLoaded) {
      checkExternalLabelVisibilityStatus();
    }

    /** Write the parameter loginNumber to indicate the amount of user logins to display the Opus access banner in footer */
    const loginNumber = window.localStorage.getItem('loginNumber');
    window.localStorage.setItem(
      'loginNumber',
      !loginNumber ? 1 : Number(loginNumber) + 1
    );
  }

  componentDidUpdate() {
    const { checkAuthenticationStatus } = this.props;
    checkAuthenticationStatus();

    /** When the user is logged in the second time, the note to hide the Opus access banner is made in kv store */
    const loginNumber = window.localStorage.getItem('loginNumber');
    /** loginNumber should be 2, because it should be 2nd login and we have received the kv user data */
    if (
      this.props.isLoadedAccessBanner &&
      (this.props.isAccessBannerShown === undefined ||
        this.props.isAccessBannerShown === null) &&
      loginNumber === '2'
    ) {
      this.props.setOpusAccessBannerView(true);
    }
  }

  render() {
    const {
      isAuthenticated,
      isExternalOneLabel,
      externalLabels,
      externalLoaded,
      render: renderFn,
      ...rest
    } = this.props;

    if (isAuthenticated) {
      // if this user is a 3rd party user and trying to access a label page
      if (
        isExternalOneLabel &&
        externalLoaded &&
        delve(this.props, ['computedMatch', 'params', 'entityType']) ===
          'label' &&
        !externalLabels.includes(
          delve(this.props, ['computedMatch', 'params', 'entityId'])
        )
      ) {
        return (
          <Redirect
            to={{
              ...this.props.location,
              pathname: '/authenticate',
              from: this.props.location,
            }}
          />
        );
      }

      return <Route {...rest} render={renderFn} />;
    }

    return (
      <Redirect
        to={{
          ...this.props.location,
          pathname: '/authenticate',
          from: this.props.location,
        }}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.authentication.isAuthenticated,
    isExternalUser: state.authentication.isExternalUser,
    isExternalOneLabel: state.authentication.isExternalOneLabel,
    externalLoaded: state.authentication.externalLoaded,
    externalLabels: state.authentication.externalLabels,
    isAccessBannerShown: state.userSettings?.data?.opusAccessFooterBanner,
    isLoadedAccessBanner:
      state.userSettings?.loading?.all === false &&
      state.userSettings?.success?.all === true,
  };
};

export default connect(mapStateToProps, {
  checkAuthenticationStatus,
  setOpusAccessBannerView,
  checkExternalLabelVisibilityStatus,
})(PrivateRoute);
